export const ShopTypes = {
  GET_SHOP_DATA_BY_CATEGORY: 'GET_SHOP_DATA_BY_CATEGORY',
  GET_SHOP_DATA_FROM_API: 'GET_SHOP_DATA_FROM_API',
  GET_SINGLE_PRODUCT_BY_ID: 'GET_SINGLE_PRODUCT_BY_ID',
}
